import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  backdrop: {
    backgroundColor: Theme.black,
    height: '100%',
    opacity: 0,
    width: '100%',
  },
  contentWrapper: {
    alignSelf: 'stretch',
    flex: 1,
    marginBottom: Theme.tvMarginVertical(),
    marginRight: Theme.tvMarginHorizontal(),
    marginTop: Theme.tvMarginVertical(),
    paddingLeft: Theme.px(80),
  },
  modalScreen: {
    height: Theme.appHeight,
    width: Theme.appWidth,
  },
  panel: {
    alignItems: 'center',
    elevation: 1,
    flex: 1,
    height: '100%',
    position: 'absolute',
    shadowColor: Theme.black,
    shadowOffset: { width: -60, height: -1 },
    shadowOpacity: 0.8,
    shadowRadius: 60,
    width: Theme.sidePanelWidth,
  },
  panelGradient: {
    height: '100%',
    width: '100%',
  },
});
